<template>
  <div class="procesos-container">
    <!-- Unified Container -->
    <div class="unified-container">
      <!-- Header Section -->
      <div class="header-section">
        <div class="title-section">
          <v-icon class="title-icon" color="white">mdi-account-tie</v-icon>
          <div class="title-text">
            <h1 class="main-title">DIRECTOR DE ÁREA</h1>
            <p class="subtitle">Gestión de procesos de compra</p>
          </div>
        </div>
        <div class="header-actions">
          <v-btn
            class="export-btn"
            @click="downloadExcel"
            outlined
            dark
          >
            <v-icon left>mdi-file-excel</v-icon>
            Exportar Excel
          </v-btn>
        </div>
      </div>

      <!-- Search Section -->
      <div class="search-section">
        <div class="search-card">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar Proceso"
            solo
            flat
            hide-details
            class="search-field"
          ></v-text-field>
        </div>
        <div class="create-btn-container">
          <v-dialog v-model="dialog" max-width="70rem" persistent overlay-color="black" overlay-opacity="0.8">
            <template v-slot:activator="{ on }">
              <v-btn class="create-btn" v-on="on">
                <v-icon left>mdi-plus-thick</v-icon>
                Crear Proceso
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-application-edit</v-icon>
                  {{ formTitle }}
                </span>
              </v-card-title>
              <!-- componente del modal para agregar y actualizar -->
              <v-card-text>
                <v-container grid-list-md>
                  <v-row>
                    <v-col cols="7" style="min-height:600px;">
                      <v-card elevation="6" class="pa-6" style="background:#f7f9fa;border-radius:18px;box-shadow:0 4px 24px #e0e0e055;">
                        <div class="font-weight-bold mb-6 text-center" style="font-size:22px;letter-spacing:1px;display:flex;align-items:center;justify-content:center;gap:10px;">
                          <v-icon color="primary" overlay-color="black" overlay-opacity="0.8">mdi-pencil-box-multiple</v-icon>
                          Formulario de proceso
                        </div>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field v-model="editedItem.concepto" label="Concepto" maxlength="80" @input="onTyping"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-text-field 
                                v-model="editedItem.cantidad" 
                                label="Cantidad" 
                                @input="formatearNumero('cantidad', $event); onTyping()"
                                @keypress="soloNumerosCantidad"
                                type="text"
                                placeholder="0"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6">
                              <v-text-field 
                                v-model="editedItem.presupuesto" 
                                label="Presupuesto" 
                                maxlength="80" 
                                @input="formatearNumero('presupuesto', $event); onTyping()"
                                @keypress="soloNumerosConDecimales"
                                type="text"
                                placeholder="0"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                              <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="editedItem.fecha"
                                    label="Fecha requerida"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    @click:prepend="menu = !menu"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  v-model="editedItem.fecha"
                                  no-title
                                  scrollable
                                  @input="menu = false; onTyping()"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
                                  <v-btn text color="primary" @click="menu = false">OK</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-select v-model="editedItem.empresa" :items="['Facilísimo', 'Apostar']" label="Empresa" single-line return-object :disabled="empresaFija !== ''" @change="onTyping"></v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field v-model="editedItem.expecificaciones" label="Detalle técnico" @input="onTyping"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field v-model="editedItem.observaciones" label="Argumento para la compra" @input="onTyping"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field v-model="editedItem.asunto" label="Asunto" maxlength="50" @input="onTyping"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-file-input
                                ref="fileInput"
                                label="Adjuntar archivos (máx. 5)"
                                accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx"
                                multiple
                                :show-size="true"
                                :disabled="selectedFile && selectedFile.length >= 5"
                                :hint="selectedFile && selectedFile.length >= 5 ? '✔ Límite de 5 archivos alcanzado' : ''"
                                persistent-hint
                                class="mr-3"
                                @change="agregarArchivos"
                              ></v-file-input>
                              <div v-if="selectedFile && selectedFile.length > 0" class="mt-2">
                                <v-chip
                                  v-for="(file, i) in selectedFile"
                                  :key="i"
                                  close
                                  class="ma-1"
                                  @click:close="eliminarArchivo(i)"
                                >
                                  {{ file.name }}
                                </v-chip>
                                <div class="caption mt-1" :class="selectedFile.length >= 5 ? 'red--text font-weight-bold' : 'grey--text'">
                                  {{ selectedFile.length }}/5 archivos
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                      <v-col cols="5" style="min-height:600px;">
                        <v-card elevation="6" class="pa-4" style="background:#fafbfc;border-radius:16px;min-height:400px;border:1px solid #e0e0e0;">
                          <div class="font-weight-bold mb-4 text-center" style="font-size:20px;letter-spacing:1px;display:flex;align-items:center;justify-content:center;gap:8px;">
                            <v-icon color="primary">mdi-format-list-bulleted</v-icon>
                            Procesos agregados
                          </div>
                          <v-list v-if="apps1.length" class="pa-0">
                            <v-list-item v-for="(proceso, idx) in apps1" :key="idx" class="mb-3" style="border-radius:10px;border:1px solid #e0e0e0;background:#fff;box-shadow:0 2px 8px #e0e0e033;">
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-bold" style="font-size:17px;">{{ proceso.concepto }} <span class="blue--text"> - {{ proceso.empresa }}</span></v-list-item-title>
                                <v-list-item-subtitle style="font-size:15px;">Cantidad: <b>{{ proceso.cantidad }}</b> | Presupuesto: <b>{{ proceso.presupuesto }}</b></v-list-item-subtitle>
                                <v-list-item-subtitle style="font-size:14px;"> Fecha: <b>{{ proceso.fecha }}</b></v-list-item-subtitle>
                                <v-list-item-subtitle style="font-size:14px;" class="mt-1">Detalle técnico: <span class="grey--text">{{ proceso.expecificaciones }}</span></v-list-item-subtitle>
                                <v-list-item-subtitle style="font-size:14px;">Argumento para la compra: <span class="grey--text">{{ proceso.observaciones }}</span></v-list-item-subtitle>
                                <v-list-item-subtitle style="font-size:14px;">Asunto: <span class="grey--text">{{ proceso.asunto }}</span></v-list-item-subtitle>
                              </v-list-item-content> 
                              <v-btn icon @click="editarProceso(idx)">
                                <v-icon color="primary">mdi-pencil</v-icon>
                              </v-btn>
                                <v-btn icon @click="apps1.splice(idx, 1)" overlay-color="black" overlay-opacity="0.8"><v-icon color="error">mdi-delete</v-icon></v-btn>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                          <div v-else class="grey--text text--darken-1 mt-5 text-center" style="font-size:18px;">No hay procesos agregados aún.</div>
                          
                          <!-- Sección de cálculos financieros -->
                          <v-divider v-if="apps1.length" class="my-4"></v-divider>
                          <div v-if="apps1.length" class="pa-3" style="background:#f0f4ff;border-radius:12px;border:1px solid #c5cae9;">
                            <div class="font-weight-bold mb-3 text-center" style="font-size:18px;color:#1976d2;">
                              <v-icon color="#1976d2" class="mr-2">mdi-calculator</v-icon>
                              Resumen Financiero
                            </div>
                            <v-row dense>
                              <v-col cols="12">
                                <div class="d-flex justify-space-between align-center pa-2" style="background:#fff;border-radius:8px;margin-bottom:8px;">
                                  <span class="font-weight-medium" style="font-size:16px;">SUBTOTAL:</span>
                                  <span class="font-weight-bold" style="font-size:16px;color:#2e7d32;">$ {{ formatearMoneda(calcularSubtotal) }}</span>
                                </div>
                              </v-col>
                              <v-col cols="12">
                                <div class="d-flex justify-space-between align-center pa-2" style="background:#fff;border-radius:8px;margin-bottom:8px;">
                                  <span class="font-weight-medium" style="font-size:16px;">IVA (19%):</span>
                                  <span class="font-weight-bold" style="font-size:16px;color:#f57c00;">$ {{ formatearMoneda(calcularIVA) }}</span>
                                </div>
                              </v-col>
                              <v-col cols="12">
                                <div class="d-flex justify-space-between align-center pa-2" style="background:#1976d2;border-radius:8px;">
                                  <span class="font-weight-bold" style="font-size:18px;color:#fff;">TOTAL:</span>
                                  <span class="font-weight-bold" style="font-size:18px;color:#fff;">$ {{ formatearMoneda(calcularTotal) }}</span>
                                </div>
                              </v-col>
                            </v-row>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn elevation="2" color="#FF2E2E" @click="close">Cancelar</v-btn>
                  <v-btn color="primary" @click="cargarProcesoYContinuar()" :disabled="!editedItem.concepto || !editedItem.cantidad || editedItem.cantidad < 1 || !editedItem.presupuesto || !editedItem.fecha || !editedItem.empresa">Agregar proceso</v-btn>
                  <v-btn color="#00CC00" 
           @click="guardarYCerrar()" 
             :disabled="apps1.length === 0 || isTyping">
             Guardar todos
             </v-btn>
                </v-card-actions>
                <!-- <pre>{{editedItem}}</pre>  -->
              </v-card>
            </v-dialog>

          <!-- Modal / Alerta Ampliada y Detallada de Confirmación de Proceso Agregado -->
          <v-dialog v-model="dialogConfirmacion" max-width="800px" persistent overlay-color="black" overlay-opacity="0.8">
            <v-card class="pa-0 overflow-hidden" style="border-radius: 18px; background: #ffffff; box-shadow: 0 16px 40px rgba(0,0,0,0.22);">
              <!-- Encabezado del Modal con Degradado Azul Elegante -->
              <v-card-title class="d-flex justify-space-between align-center py-4 px-6" style="background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%); color: white;">
                <div class="d-flex align-center" style="gap: 12px;">
                  <v-icon color="#ffffff" size="30">mdi-check-decagram</v-icon>
                  <div>
                    <div class="font-weight-bold" style="font-size: 20px; letter-spacing: -0.3px; line-height: 1.2;">
                      Proceso Agregado Correctamente
                    </div>
                    <div style="font-size: 13px; opacity: 0.9; font-weight: 400;">
                      Revisa la información completa antes de enviar la solicitud
                    </div>
                  </div>
                </div>
                <v-btn icon dark small @click="dialogConfirmacion = false" style="background: rgba(255,255,255,0.15);">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <!-- Contenido / Resumen Detallado de Todos los Campos del Formulario -->
              <v-card-text class="pt-5 px-6 pb-2" style="max-height: 70vh; overflow-y: auto;">
                <!-- Banner cuando hay más de 1 producto -->
                <div v-if="apps1.length > 1" class="mb-4 d-flex align-center justify-space-between" style="background: #eff6ff; border: 1px solid #bfdbfe; padding: 10px 16px; border-radius: 10px; color: #1e40af; font-weight: 600; font-size: 14px;">
                  <div class="d-flex align-center" style="gap: 8px;">
                    <v-icon color="#1d4ed8">mdi-layers-triple</v-icon>
                    <span>Resumen total: {{ apps1.length }} productos agregados en este proceso</span>
                  </div>
                  <v-chip x-small color="#1d4ed8" dark class="font-weight-bold">Multi-producto</v-chip>
                </div>

                <!-- Tarjetas Detalladas de Productos -->
                <div v-for="(proceso, idx) in apps1" :key="idx" class="mb-4" style="background: #fafafa; border: 1px solid #e2e8f0; border-radius: 12px; overflow: hidden; box-shadow: 0 2px 6px rgba(0,0,0,0.03);">
                  <!-- Encabezado del ítem -->
                  <div class="px-4 py-2 d-flex justify-space-between align-center" style="background: #f1f5f9; border-bottom: 1px solid #e2e8f0;">
                    <span class="font-weight-bold" style="color: #1e293b; font-size: 15px;">
                      Producto #{{ idx + 1 }}: <span class="primary--text">{{ proceso.concepto }}</span>
                    </span>
                    <v-chip x-small color="primary" outlined class="font-weight-bold">{{ proceso.empresa }}</v-chip>
                  </div>

                  <!-- Campos del Formulario -->
                  <div class="pa-4">
                    <v-row dense>
                      <v-col cols="12" sm="6">
                        <div class="mb-2">
                          <span class="caption grey--text text--darken-1 font-weight-bold">CONCEPTO</span>
                          <div class="body-2 font-weight-bold" style="color: #0f172a;">{{ proceso.concepto }}</div>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <div class="mb-2">
                          <span class="caption grey--text text--darken-1 font-weight-bold">EMPRESA</span>
                          <div class="body-2 font-weight-bold primary--text">{{ proceso.empresa }}</div>
                        </div>
                      </v-col>

                      <v-col cols="6" sm="3">
                        <div class="mb-2">
                          <span class="caption grey--text text--darken-1 font-weight-bold">CANTIDAD</span>
                          <div class="body-2 font-weight-bold" style="color: #0f172a;">{{ proceso.cantidad }}</div>
                        </div>
                      </v-col>

                      <v-col cols="6" sm="3">
                        <div class="mb-2">
                          <span class="caption grey--text text--darken-1 font-weight-bold">PRESUPUESTO</span>
                          <div class="body-2 font-weight-bold" style="color: #15803d;">$ {{ proceso.presupuesto }}</div>
                        </div>
                      </v-col>

                      <v-col cols="6" sm="3">
                        <div class="mb-2">
                          <span class="caption grey--text text--darken-1 font-weight-bold">FECHA REQUERIDA</span>
                          <div class="body-2 font-weight-bold" style="color: #0f172a;">{{ proceso.fecha }}</div>
                        </div>
                      </v-col>

                      <v-col cols="6" sm="3">
                        <div class="mb-2">
                          <span class="caption grey--text text--darken-1 font-weight-bold">ASUNTO</span>
                          <div class="body-2 font-weight-bold" style="color: #0f172a;">{{ proceso.asunto || 'N/A' }}</div>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6" v-if="proceso.expecificaciones">
                        <div class="mb-2">
                          <span class="caption grey--text text--darken-1 font-weight-bold">DETALLE TÉCNICO</span>
                          <div class="body-2 grey--text text--darken-3 pa-2" style="background: #ffffff; border-radius: 6px; border: 1px solid #e2e8f0;">
                            {{ proceso.expecificaciones }}
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6" v-if="proceso.observaciones">
                        <div class="mb-2">
                          <span class="caption grey--text text--darken-1 font-weight-bold">ARGUMENTO PARA LA COMPRA</span>
                          <div class="body-2 grey--text text--darken-3 pa-2" style="background: #ffffff; border-radius: 6px; border: 1px solid #e2e8f0;">
                            {{ proceso.observaciones }}
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <!-- Sección de Archivos Adjuntos si los hay -->
                <div v-if="selectedFile && selectedFile.length > 0" class="mb-4 pa-3" style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px;">
                  <span class="caption grey--text text--darken-2 font-weight-bold d-block mb-1">
                    <v-icon small color="primary" class="mr-1">mdi-paperclip</v-icon>
                    ARCHIVOS ADJUNTOS ({{ selectedFile.length }}):
                  </span>
                  <div class="d-flex flex-wrap gap-1">
                    <v-chip v-for="(file, fIdx) in selectedFile" :key="fIdx" small class="ma-1" color="blue-grey lighten-5 text--darken-3">
                      <v-icon left small color="primary">mdi-file-document</v-icon>
                      {{ file.name }}
                    </v-chip>
                  </div>
                </div>

                <!-- Resumen Financiero Total -->
                <div class="pa-4" style="background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%); border-radius: 14px; color: #ffffff; box-shadow: 0 4px 14px rgba(30,58,138,0.25);">
                  <div class="d-flex justify-space-between align-center mb-2" style="font-size: 14px; opacity: 0.9;">
                    <span>SUBTOTAL:</span>
                    <span class="font-weight-bold">$ {{ formatearMoneda(calcularSubtotal) }}</span>
                  </div>
                  <div class="d-flex justify-space-between align-center mb-2" style="font-size: 14px; opacity: 0.9;">
                    <span>IVA (19%):</span>
                    <span class="font-weight-bold" style="color: #fbbf24;">$ {{ formatearMoneda(calcularIVA) }}</span>
                  </div>
                  <v-divider dark class="my-2" style="opacity: 0.3;"></v-divider>
                  <div class="d-flex justify-space-between align-center" style="font-size: 18px;">
                    <span class="font-weight-bold">TOTAL FINAL (con IVA):</span>
                    <span class="font-weight-black text-h6 yellow--text text--accent-2">$ {{ formatearMoneda(calcularTotal) }}</span>
                  </div>
                </div>
              </v-card-text>

              <!-- Botones de Acción -->
              <v-card-actions class="pa-6 d-flex flex-column" style="gap: 12px; background: #ffffff; border-top: 1px solid #f1f5f9;">
                <v-btn
                  block
                  x-large
                  elevation="3"
                  style="background-color: #16a34a !important; color: #ffffff !important; font-weight: 700; font-size: 16px; letter-spacing: 0.5px; border-radius: 10px; text-transform: uppercase;"
                  @click="enviarDesdeModalConfirmacion"
                >
                  <v-icon left size="24" color="white">mdi-send-check</v-icon>
                  ENVIAR PROCESO AHORA
                </v-btn>

                <v-btn
                  block
                  text
                  style="color: #64748b; font-weight: 600; font-size: 14px;"
                  @click="dialogConfirmacion = false"
                >
                  <v-icon left small>mdi-plus-circle-outline</v-icon>
                  Agregar otro producto / Modificar antes de enviar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Dialog para agregar observación -->
          <v-dialog v-model="dialogObservacion" max-width="500px" persistent overlay-color="black" overlay-opacity="0.8">
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-comment-plus</v-icon overlay-color="black" overlay-opacity="0.8">
                  Agregar Observación
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-textarea
                        v-model="nuevaObservacion"
                        label="Argumento para la compra"
                        placeholder="Escribe tu observación aquí..."
                        rows="4"
                        counter="500"
                        maxlength="500"
                        outlined
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn elevation="2" color="#f7e506" @click="cerrarObservacion">
                  Cancelar
                </v-btn>
                <v-btn
                  color="#f7e506"
                  @click="guardarObservacion"
                  :disabled="!nuevaObservacion || nuevaObservacion.trim() === ''"
                >
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>

      <!-- Table Section -->
      <div class="table-section">
        <div class="table-card">
          <v-data-table
            :headers="headers"
            :items="apps"
            :search="search"
            class="modern-table"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [10, 20, 50],
              'items-per-page-text': 'Filas por página:',
            }"
          >
            <template v-slot:no-data>
              <v-alert
                :value="true"
                color="#F44336"
                icon="mdi-alert"
                outlined
                type="warning"
                prominent
                border="left"
              >
                <strong>No</strong> se encontró su búsqueda
              </v-alert>
            </template>
            <template v-slot:[`item.procesos`]="{ item }">
              <v-icon
                class="pdf-icon"
                @click="pdfProcesos(item)"
                title="Ver PDF"
              >
                mdi-file-pdf-box
              </v-icon>
            </template>
            <template v-slot:[`item.archivo`]="{ item }">
              <v-icon
                v-if="item.ruta_img"
                class="view-icon"
                @click="verArchivos(item)"
                title="Ver archivos"
              >
                mdi-eye
              </v-icon>
            </template>
            <template v-slot:[`item.acciones`]="{ item }">
              <div class="action-icons">
                <!-- Botón para marcar compra como realizada -->
                <v-icon
                  v-if="item.estado === '7' || item.estado === '6'"
                  class="action-icon approve-icon"
                  @click="marcarCompraRealizada(item)"
                  :disabled="item.loading"
                  title="Marcar compra realizada"
                >
                  mdi-check-bold
                </v-icon>
                <!-- Botón para agregar observación -->
                <v-icon
                  class="action-icon comment-icon"
                  @click="agregarObservacion(item)"
                  title="Agregar observación"
                >
                  mdi-comment-plus
                </v-icon>
              </div>
            </template>
                  <template v-slot:[`item.estado`]="{ item }">
                    <div v-if="item.estado === '0'">
                    <v-chip outlined class="ma-2" color="red">
                      CANCELADO
                    </v-chip>
                  </div>
                  <div v-if="item.estado === '1'">
                    <v-chip outlined class="ma-2" color="orange darken-2">
                      GERENTE
                    </v-chip>
                  </div>
                  <div v-if="item.estado === '3' || item.estado === '2'">
                    <v-chip outlined class="ma-2" color="amber accent-4">
                      COMPRAS
                    </v-chip>
                  </div>
                  
                  <div v-if="item.estado === '5'">
                    <v-chip outlined class="ma-2" color="green darken-4">
                      DIRECCION FINANCIERA
                    </v-chip>
                  </div>
                  <div v-if="item.estado === '4'">
                    <v-chip outlined class="ma-2" color="green">
                      APROBACION DIRECTOR AREA
                    </v-chip>
                  </div>
                  <div v-if="item.estado === '6'">
                    <v-chip outlined class="ma-2" color="green">
                      APROBACION GERENTE
                    </v-chip>
                  </div>
                  <div v-if="item.estado === '7'">
                    <v-chip outlined class="ma-2" color="green">
                      REALIZAR COMPRA
                    </v-chip>
                  </div>
                  <div v-if="item.estado === '8'">
                      <v-chip outlined class="ma-2" color="green">
                          COMPRA REALIZADA
                      </v-chip>
                  </div>
            </template>
          </v-data-table>
        </div>
      </div>


          <v-dialog v-model="dialogPdf" persistent max-width="60rem" overlay-color="black" overlay-opacity="0.8">
            <v-card style="max-width: 900px; width: 100%;">
              <v-card-title class="nav">
                <span class="headline" style="color: white" overlay-color="black"
                        overlay-opacity="0.8">
                  <v-icon color="white">mdi-clipboard-edit-outline</v-icon>
                  Editar Proceso
                </span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout v-for="(item, index) in editedItem.infoProceso" :key="index">
                    <v-card class="mt-5" width="98%" elevation="4">
                      <v-layout wrap class="pl-7 pt-4 pr-7">
                        <v-flex xs6 sm6 md6>
                          <v-text-field v-model="item.concepto" label="Concepto" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                          <v-text-field v-model="item.cantidad" type="number" min="0" label="Cantidad" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                          <v-text-field v-model="item.presupuesto" type="number" min="0" label="Presupuesto" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                          <v-text-field v-model="item.fecha" type="date" min="0" label="Fecha" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field v-model="item.empresa" label="Empresa" single-line return-object disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-textarea v-model="item.expecificaciones" label="Detalle técnico" disabled></v-textarea>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-textarea v-model="item.observaciones" label="Argumento para la compra" disabled></v-textarea>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-layout>
                  <!-- <pre>{{editedItem}}</pre> -->

                </v-container>
              </v-card-text>
              <!-- botones para cancelar y agregregar y validacion de campos vacios -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn elevation="2" color="#f7e506" @click="close">Cerrar</v-btn>

              </v-card-actions>
              <!-- <pre>{{editedItem}}</pre>  -->
            </v-card>
          </v-dialog>
      <!-- Snackbar para notificaciones -->
      <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        color="#3b82f6"
        class="modern-snackbar"
      >
        {{ text }}
        <v-btn color="white" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>

          <!-- Dialog para ver archivos adjuntos -->
          <v-dialog v-model="dialogArchivos" max-width="900px" overlay-color="black" overlay-opacity="0.8">
            <v-card>
              <v-card-title class="headline">Archivos Adjuntos</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col v-for="(archivo, idx) in archivosModal" :key="idx" cols="12" sm="6" md="4" lg="3" class="d-flex flex-column align-center">
                    <div v-if="esImagen(archivo)" class="archivo-preview" @click="abrirArchivo(archivo)" style="cursor:pointer;width:180px;height:180px;display:flex;align-items:center;justify-content:center;background:#f5f5f5;border-radius:8px;overflow:hidden;">
                      <v-img :src="archivo" contain height="100%" width="100%" />
                    </div>
                    <div v-else class="archivo-preview d-flex flex-column align-center justify-center" @click="abrirArchivo(archivo)" style="cursor:pointer;width:180px;height:180px;display:flex;align-items:center;justify-content:center;background:#f5f5f5;border-radius:8px;overflow:hidden;">
                      <v-icon color="primary" size="60">mdi-file-document</v-icon>
                      <span class="mt-2 text-center" style="font-size:13px;word-break:break-all;">{{ nombreArchivo(archivo) }}</span>
                    </div>
                    <div v-if="esImagen(archivo)" class="mt-2 text-center" style="font-size:13px;word-break:break-all;max-width:180px;">{{ nombreArchivo(archivo) }}</div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="dialogArchivos = false">Cerrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </div>
    </div>
</template>

<script>
import axios from "axios";
import env from "../env";
import swal from "sweetalert";
import XLSX from "xlsx";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      apps: [],
      apps1: [],
      empresaFija: '',
      isSending: false,
      menu: false, // Para el date picker
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalido e-mail.";
        },
      },
      dialog: false,
      dialogPdf: false,
      dialogObservacion: false,
      dialogArchivos: false,
      nuevaObservacion: "",
      procesoSeleccionado: null,
      loader: true,
      loading: false,
      envia: true,
      contadorTabla: 0,
      estadoTabla: false,
      selectedFile: [],
      getFile:null,
      archivosModal: [],
      headers: [
        {
          text: "ID",
          value: "idProceso",
          align: "center",
          class: "column",
          width: "70px",
        },
        {
          text: "Concepto",
          value: "infofrase",
          align: "left",
          class: "column",
          width: "350px",
        },
        {
          text: "Empresa",
          value: "empresa",
          align: "center",
          class: "column",
          width: "120px",
        },
        {
          text: "Procesos",
          value: "procesos",
          align: "center",
          class: "column",
          width: "100px",
        },
        {
          text: "Fecha",
          value: "fechaCreacion",
          align: "center",
          class: "column",
          width: "120px",
        },
        {
          text: "Estado",
          value: "estado",
          align: "center",
          class: "column",
          width: "180px",
        },
        {
          text: "Fecha entrega",
          value: "fechaEntrega",
          align: "center",
          class: "column",
          width: "130px",
        },
        {
          text: "Adjunto",
          value: "archivo",
          align: "center",
          class: "column",
          width: "100px",
        },
        {
          text: "Acciones",
          value: "acciones",
          align: "center",
          class: "column",
          width: "120px",
          sortable: false,
        }
      ],
      headers1: [
        {
          text: "ID",
          value: "id",
          align: "center",
          class: "column",
        },
        {
          text: "Concepto",
          value: "concepto",
          align: "center",
          class: "column",
        },
        {
          text: "Cantidad",
          value: "cantidad",
          align: "center",
          class: "column",
        },
        {
          text: "Presupuesto",
          value: "presupuesto",
          align: "center",
          class: "column",
        },
        {
          text: "Fecha",
          value: "fecha",
          align: "center",
          class: "column",
        },
        {
          text: "Empresa",
          value: "empresa",
          align: "center",
          class: "column",
        },
        {
          text: "Detalle técnico",
          value: "expecificaciones",
          align: "center",
          class: "column",
        },
        {
          text: "Argumento para la compra",
          value: "observaciones",
          align: "center",
          class: "column",
        },
        {
          text: "Asunto",
          value: "asunto",
          align: "center",
          class: "column",
        },
        {
          text: "Acciones",
          value: "actions",
          align: "center",
          class: "column",
          sortable: false,
        },
      ],
      defaultItem: {
        id: "",
        concepto: "",
        cantidad: "",
        expecificaciones: "",
        observaciones: "",
      },
      editedIndex: -1,
      editedItem: {
        id: "",
        concepto: "",
        cantidad: "",
        presupuesto: "",
        fecha: "",
        empresa: "",
        expecificaciones: "",
        observaciones: "",
      },
      isTyping: false,
      dialogConfirmacion: false,
      ultimoProcesoAgregado: null,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Crear Proceso" : "Editar Aplicacion";
    },
    // Cálculo del SUBTOTAL: suma de todos los presupuestos de los procesos
    calcularSubtotal() {
      return this.apps1.reduce((total, proceso) => {
        const presupuesto = this.parsearNumero(proceso.presupuesto);
        return total + presupuesto;
      }, 0);
    },
    // Cálculo del IVA: 19% del subtotal
    calcularIVA() {
      return this.calcularSubtotal * 0.19;
    },
    // Cálculo del TOTAL: subtotal + IVA
    calcularTotal() {
      return this.calcularSubtotal + this.calcularIVA;
    },
    // eliminado isTyping computado, ahora es flag en data controlado por eventos
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.close();
      } else {
        // Si ya hay una empresa fija, precargarla en el formulario al abrir
        if (this.empresaFija) {
          this.$nextTick(() => {
            this.editedItem.empresa = this.empresaFija;
          });
        }
      }
    },
  },

  mounted() {
    this.obtenerApps();
    console.log('este es el archivo',this.getFile);
  },

  methods: {
    viewImage(rutaImg) {
        window.open(rutaImg, '_blank');
    },
    // Metodo para obtener las aplicaciones
    obtenerApps() {
      axios.get(`${env.endpoint}user/procesos?idUser=${localStorage.getItem("id")}`)
        .then(res => {
          this.apps = res.data

          this.apps = this.apps.map(proceso => {
            proceso.infofrase = proceso.infoProceso.map(element => element.concepto).join(', ');
            proceso.loading = false; // Añadir estado de loading para cada proceso
            return proceso;
          });
          this.apps = this.apps.map(proceso => {
           proceso.empresa = [...new Set(proceso.infoProceso.map(e => e.empresa))].join(', ');
            return proceso;
          });
        });
    },

    // Método para marcar compra como realizada
    marcarCompraRealizada(item) {
      swal({
        title: "Marcar compra como realizada",
        text: "¿Estás seguro de que deseas marcar esta compra como realizada?",
        icon: "warning",
        buttons: ["Cancelar", "Confirmar"],
        dangerMode: false,
      }).then((willConfirm) => {
        if (willConfirm) {
          // Activar loading en el botón
          this.$set(item, 'loading', true);
          // Mostrar overlay global
          this.showGlobalOverlay("Procesando actualización...");
          
          const formData = new FormData();
          formData.append("idProceso", item.idProceso);
          formData.append("estado", 8); // Estado 8 = Compra Realizada
          formData.append("idUser", localStorage.getItem("id"));
          
          axios.post(`${env.endpoint}user/actualizarEstadoProceso`, formData)
            .then((res) => {
              // Actualizar mensaje del overlay
              this.showGlobalOverlay("Actualizando datos...");
              if (res.data.success) {
                // Actualizar el estado localmente
                item.estado = '8';
                
                swal("¡Éxito!", "La compra ha sido marcada como realizada", "success");
                
                // Refrescar la lista de procesos
                this.obtenerApps();
              } else {
                swal("Error", "No se pudo actualizar el estado del proceso", "error");
              }
            })
            .catch((error) => {
              console.error('Error al actualizar estado:', error);
              swal("Error", "Ha ocurrido un error al actualizar el estado. Intente de nuevo.", "error");
            })
            .finally(() => {
              // Desactivar loading
              this.$set(item, 'loading', false);
              this.hideGlobalOverlay();
            });
        }
      });
    },

    // Método para abrir el diálogo de observación
   // Método para abrir el diálogo de observación
   agregarObservacion(item) {
      this.procesoSeleccionado = item;
      this.nuevaObservacion = "";
      this.dialogObservacion = true;
    },

    // Método para cerrar el diálogo de observación
    cerrarObservacion() {
      this.dialogObservacion = false;
      this.nuevaObservacion = "";
      this.procesoSeleccionado = null;
    },

    // Método para guardar la observación
    guardarObservacion() {
      if (!this.nuevaObservacion || this.nuevaObservacion.trim() === "") {
        swal("Error", "Debes escribir una observación", "error");
        return;
      }

      const formData = new FormData();
      formData.append("idProceso", this.procesoSeleccionado.idProceso);
      formData.append("observacion", this.nuevaObservacion.trim());
      formData.append("idUser", localStorage.getItem("id"));
      formData.append("idRol", "3");

      swal({
        title: "Agregar observación",
        text: "¿Estás seguro de que deseas agregar esta observación?",
        icon: "info",
        buttons: ["Cancelar", "Confirmar"],
        dangerMode: false,
      }).then((willConfirm) => {
        if (willConfirm) {
          axios.post(`${env.endpoint}user/agregarObservacionProceso`, formData)
            .then((res) => {
              if (res.data.success) {
                swal("¡Éxito!", "La observación ha sido agregada correctamente", "success");
                this.cerrarObservacion();
                this.obtenerApps(); // Refrescar la lista de procesos
              } else {
                swal("Error", "No se pudo agregar la observación", "error");
              }
            })
            .catch((error) => {
              console.error('Error al agregar observación:', error);
              swal("Error", "Ha ocurrido un error al agregar la observación. Intente de nuevo.", "error");
            });
        }
      });
    },

    /**
     * Metodo para agregar fila de la tabla en la modal
     */
    editItem(item) {
      this.editedIndex = this.apps1.indexOf(item);
      // console.log("el valor de editar es:", item)
      this.editedItem = Object.assign({}, item);
      // console.log("el valor de  ", this.editedIndex)
      // console.log("el valor de editedItem", this.editedItem)
      this.dialog = true;
    },

    async submitUpload() {
      try {
        if (!this.selectedFile || this.selectedFile.length === 0) {
          alert("Por favor, selecciona al menos un archivo.");
          return;
        }
        if (this.selectedFile.length > 5) {
          alert("Solo puedes subir hasta 5 archivos.");
          return;
        }
        const formData = new FormData();
        this.selectedFile.forEach((file) => {
          formData.append('files[]', file);
        });
          formData
        await axios.post('http://localhost:8787/compras/archivos/uploadAreaProcesos.php', formData).then((res) => {
          if (res.data.status === 'success') {
            this.getFile = res.data.paths || res.data.path;
            console.log(this.getFile);
            swal("¡Archivos cargados correctamente!", {
              icon: "success",
            });
            return this.getFile;
          } else {
            alert(res.data.message || 'Error al cargar los archivos');
          }
        });
      } catch (error) {
        console.error('Error al cargar los archivos:', error);
        alert('Hubo un error al cargar los archivos');
      } finally {
        this.selectedFile = [];
      }
    },

    /**
     * Metodo para cerrar la modal
     */
     close() {
      this.dialog = false;
      this.dialogPdf = false;
      this.dialogConfirmacion = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        // Al cerrar, desbloquear empresa
        this.empresaFija = '';
        this.ultimoProcesoAgregado = null;
      }, 300);
    },

    cargartabla(cerrar = true) {
      // Solo cerrar el modal, no agregar proceso extra
      this.close();
      // Al cerrar, desbloquear empresa para el siguiente proceso
      this.empresaFija = '';
    },
    cargarProcesoYContinuar() {
      const itemAgregado = { ...this.editedItem };
      if (this.editedIndex > -1) {
        this.apps1.splice(this.editedIndex, 1, itemAgregado);
        this.editedIndex = -1;
      } else {
        this.apps1.push(itemAgregado);
      }

      this.ultimoProcesoAgregado = itemAgregado;

      // Fijar la empresa seleccionada la primera vez para bloquear el select
      if (!this.empresaFija && itemAgregado && itemAgregado.empresa) {
        this.empresaFija = itemAgregado.empresa;
      }

      // Limpiar formulario para agregar otro sin cerrar la modal (no resetear empresaFija)
      this.editedItem = { concepto:'', cantidad:null, presupuesto:null, fecha:'', empresa: this.empresaFija || '', expecificaciones:'', observaciones:'', asunto:'' };
      this.isTyping = false;
    },
    pdfProcesos(item) {
      this.editedIndex = this.apps1.indexOf(item);
      this.editedItem = Object.assign({}, item);
      console.log(this.editedItem);
      this.dialogPdf = true;
    },
    deleteItem(item) {
      swal({
        title: "Este registro sera eliminado permanentemente.",
        text: "Una vez eliminado no se podra recuperar.",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      });
      const posicion = this.apps1.indexOf(item);
      // console.log("el valor de editar es:", item)
      this.apps1.splice(posicion,1)
      .then((willDelete) => {
        if (willDelete) {
          axios
            .get(`${env.endpoint}user/delete_config?id=${item.id}`)
            .then((res) => {
              swal("Registro eliminado con exito!", {
                icon: "success",
              });
            })
            .then((otherProcess) => {
              this.obtenerApps1();
            })
            .catch((error) => {
              this.text =
                "Ha ocurrido un error, intente de nuevo. Si el problema persiste comuníquese con el área de sistemas";
            });
        } else {
          swal("Proceso de eliminacion cancelado");
        }
      });
    },
    /**
     * Metodo para guardar
     */
Enviar() {
  if (this.isSending) return;
  this.isSending = true;

  const formData = new FormData();
  formData.append('info', JSON.stringify(this.apps1));
  formData.append('idUser', localStorage.getItem("id"));
  if (this.selectedFile && this.selectedFile.length > 0) {
    this.selectedFile.forEach((file) => {
      formData.append('files[]', file);
    });
  }
  swal({
    title: "Se enviará los procesos.",
    text: "¿Estás seguro que deseas enviar?",
    icon: "warning",
    buttons: ["Cancelar", true],
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      // Mostrar estado de carga
      swal({
        title: "Cargando...",
        text: "Enviando los datos, por favor espera.",
        icon: "info",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
        timer: false,
      });

      axios
        .post(`${env.endpoint}user/createProceso`, formData)
        .then((res) => {
          // Al enviar con éxito, mostrar alerta de éxito
          swal("Se ha enviado con éxito!", {
            icon: "success",
          });
        })
        .catch((error) => {
          // En caso de error, mostrar mensaje de error
          swal("Ha ocurrido un error, intente de nuevo.", {
            icon: "error",
          });
        })
        .finally(() => {
          // Resetear datos y estado de la tabla
          this.apps1 = [];
          this.estadoTabla = false;
          this.obtenerApps();
          this.close();
          this.contadorTabla = 0;
          this.isSending = false;
          this.dialogConfirmacion = false;
        });
    } else {
      this.isSending = false;
      swal("Proceso de envío ha sido cancelado");
    }
  });
},

  editarProceso(idx) {
      this.editedIndex = idx;           // Guardamos el índice del proceso que editaremos
      this.editedItem = { ...this.apps1[idx] }; // Hacemos un clon del proceso en el formulario
      this.dialog = true;               // Abrimos el modal
    },

    enviarDesdeModalConfirmacion() {
      this.dialogConfirmacion = false;
      this.Enviar();
    },

    agregarArchivos(nuevosArchivos) {
    if (!nuevosArchivos || nuevosArchivos.length === 0) return;

    const combinados = [...(this.selectedFile || []), ...nuevosArchivos];

    if (combinados.length > 5) {
      swal("Límite alcanzado", "Solo puedes adjuntar un máximo de 5 archivos.", "warning");
      this.selectedFile = combinados.slice(0, 5);
    } else {
      this.selectedFile = combinados;
    }

    // Limpiar el input para permitir volver a seleccionar
    this.$nextTick(() => {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.reset();
      }
    });

    this.onTyping();
  },

  eliminarArchivo(index) {
    this.selectedFile.splice(index, 1);
  },
    guardarYCerrar() {
      // Si el usuario llenó datos en el formulario sin darle previamente a "Agregar proceso", agregarlo automáticamente
      if (this.editedItem && this.editedItem.concepto && this.editedItem.cantidad && this.editedItem.presupuesto && this.editedItem.fecha && this.editedItem.empresa) {
        const itemAgregado = { ...this.editedItem };
        if (this.editedIndex > -1) {
          this.apps1.splice(this.editedIndex, 1, itemAgregado);
          this.editedIndex = -1;
        } else {
          this.apps1.push(itemAgregado);
        }
        if (!this.empresaFija && itemAgregado && itemAgregado.empresa) {
          this.empresaFija = itemAgregado.empresa;
        }
        this.ultimoProcesoAgregado = itemAgregado;
        this.editedItem = { concepto:'', cantidad:null, presupuesto:null, fecha:'', empresa: this.empresaFija || '', expecificaciones:'', observaciones:'', asunto:'' };
      }

      if (!this.apps1 || this.apps1.length === 0) {
        swal("Atención", "Debes agregar al menos un proceso antes de continuar.", "warning");
        return;
      }

      // Abrir la alerta/modal de confirmación con el resumen completo de todo lo agregado
      this.dialogConfirmacion = true;
    },

    downloadExcel() {
      const reportes = [];
      try {
          for (let i = 0; i < this.apps.length; i++) {
              const proceso = this.apps[i];
              if (proceso.infoProceso && Array.isArray(proceso.infoProceso)) {
                  for (let j = 0; j < proceso.infoProceso.length; j++) {
                      const info = proceso.infoProceso[j];
                      const item = {};
                        item.ID = proceso.idProceso;
                        item.Director = proceso.nombre;
                        item.Cedula = proceso.cedula;
                        item.Correo = proceso.correo;
                        item.Area = proceso.nombreArea;
                        item.Fecha_creacion = proceso.fechaCreacion;
                        item.Fecha_entrega = proceso.fechaEntrega;

                        if (proceso.estado === "1") {
                            item.Estado = "Gerencia";
                        } else if (proceso.estado === "2") {
                            item.Estado = "Compras";
                        } else if (proceso.estado === "3") {
                            item.Estado = "Proveedores";
                        } else if (proceso.estado === "4") {
                            item.Estado = "Pendiente aprobación director area";
                        } else if (proceso.estado === "5") {
                            item.Estado = "Pendiente aprobación direccion financiera";
                        } else if (proceso.estado === "6") {
                            item.Estado = "Pendiente aprobación gerencia";
                        } else if (proceso.estado === "7") {
                            item.Estado = "Realizar compra";
                        } else if (proceso.estado === "8") {
                            item.Estado = "Compra realizada";
                        }
                          // Extraer datos anidados
                          item.Asunto = info.asunto || '';
                          item.Cantidad = info.cantidad || '';
                          item.Concepto = info.concepto || '';
                          item.Detalle_Tecnico = info.expecificaciones || '';
                          item.Fecha = info.fecha || '';
                          item.Empresa = info.Empresa || '';
                          item.Argumento_para_la_compra = info.observaciones || '';
                          item.Presupuesto = info.presupuesto || '';
                      reportes.push(item);
                  }
              } else {
                  const item = {};
                      item.ID = proceso.idProceso;
                      item.Director = proceso.nombre;
                      item.Cedula = proceso.cedula;
                      item.Correo = proceso.correo;
                      item.Area = proceso.nombreArea;
                      item.Fecha_creacion = proceso.fechaCreacion;
                      item.Fecha_entrega = proceso.fechaEntrega;

                      if (proceso.estado === "1") {
                          item.Estado = "Gerencia";
                      } else if (proceso.estado === "2") {
                          item.Estado = "Compras";
                      } else if (proceso.estado === "3") {
                          item.Estado = "Proveedores";
                      } else if (proceso.estado === "4") {
                          item.Estado = "Pendiente aprobación director area";
                      } else if (proceso.estado === "5") {
                          item.Estado = "Pendiente aprobación ";
                      } else if (proceso.estado === "6") {
                          item.Estado = "Pendiente aprobación gerencia";
                      } else if (proceso.estado === "7") {
                          item.Estado = "Realizar compra";
                      } else if (proceso.estado === "8") {
                          item.Estado = "Compra realizada";
                      }
                      // Extraer datos anidados
                      item.Asunto = '';
                      item.Cantidad = '';
                      item.Concepto = '';
                      item.Especificaciones = '';
                      item.Fecha = '';
                      item.Empresa = '';
                      item.Observaciones = '';
                      item.Presupuesto = '';
                  reportes.push(item);
              }
          }
      } catch (error) {
          console.log(error);
      }
      const data = XLSX.utils.json_to_sheet(reportes);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `ReporteComprasDirector.xlsx`);
  },

  esImagen(archivo) {
    return /\.(jpg|jpeg|png|gif)$/i.test(archivo);
  },
  nombreArchivo(archivo) {
    return archivo.split('/').pop();
  },
  abrirArchivo(archivo) {
    window.open(archivo, '_blank');
  },
  // Overlay global montado en body
  showGlobalOverlay(mensaje) {
    this.hideGlobalOverlay();
    const overlay = document.createElement("div");
    overlay.id = "global-loading-overlay";
    overlay.style.position = "fixed";
    overlay.style.top = "0";
    overlay.style.left = "0";
    overlay.style.width = "100%";
    overlay.style.height = "100%";
    overlay.style.background = "rgba(0,0,0,0.6)";
    overlay.style.zIndex = "9999";
    overlay.style.display = "flex";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.backdropFilter = "blur(2px)";

    const card = document.createElement("div");
    card.style.background =
      "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)";
    card.style.borderRadius = "12px";
    card.style.padding = "32px 40px";
    card.style.minWidth = "320px";
    card.style.maxWidth = "90%";
    card.style.boxShadow =
      "0 20px 60px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.1)";
    card.style.display = "flex";
    card.style.flexDirection = "column";
    card.style.alignItems = "center";
    card.style.textAlign = "center";
    card.style.border = "1px solid rgba(255,255,255,0.2)";
    card.style.position = "relative";
    card.style.overflow = "hidden";

    const shine = document.createElement("div");
    shine.style.position = "absolute";
    shine.style.top = "0";
    shine.style.left = "-100%";
    shine.style.width = "100%";
    shine.style.height = "100%";
    shine.style.background =
      "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)";
    shine.style.animation = "shine 2s ease-in-out infinite";
    card.appendChild(shine);

    const spinnerContainer = document.createElement("div");
    spinnerContainer.style.position = "relative";
    spinnerContainer.style.marginBottom = "20px";

    const spinner = document.createElement("div");
    spinner.style.border = "4px solid rgba(25,118,210,0.1)";
    spinner.style.borderTop = "4px solid #1976d2";
    spinner.style.borderRadius = "50%";
    spinner.style.width = "60px";
    spinner.style.height = "60px";
    spinner.style.animation = "spin 1s linear infinite";
    spinner.style.position = "relative";
    spinner.style.zIndex = "2";

    const spinner2 = document.createElement("div");
    spinner2.style.border = "3px solid rgba(76,175,80,0.1)";
    spinner2.style.borderTop = "3px solid #4caf50";
    spinner2.style.borderRadius = "50%";
    spinner2.style.width = "40px";
    spinner2.style.height = "40px";
    spinner2.style.animation = "spin 1.5s linear infinite reverse";
    spinner2.style.position = "absolute";
    spinner2.style.top = "10px";
    spinner2.style.left = "10px";
    spinner2.style.zIndex = "1";

    spinnerContainer.appendChild(spinner);
    spinnerContainer.appendChild(spinner2);

    const text = document.createElement("div");
    text.style.fontSize = "16px";
    text.style.fontWeight = "600";
    text.style.color = "#424242";
    text.style.marginBottom = "8px";
    text.style.letterSpacing = "0.2px";
    text.style.fontFamily =
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
    text.textContent = mensaje || "Procesando...";

    const subText = document.createElement("div");
    subText.style.fontSize = "13px";
    subText.style.fontWeight = "400";
    subText.style.color = "#757575";
    subText.style.opacity = "0.9";
    subText.style.fontFamily =
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
    subText.textContent = "Por favor espere un momento";

    card.appendChild(spinnerContainer);
    card.appendChild(text);
    card.appendChild(subText);
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    if (!document.getElementById("loading-animations")) {
      const style = document.createElement("style");
      style.id = "loading-animations";
      style.textContent = `
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        @keyframes shine { 0% { left: -100%; } 100% { left: 100%; } }
      `;
      document.head.appendChild(style);
    }
  },
  hideGlobalOverlay() {
    const overlay = document.getElementById("global-loading-overlay");
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
  },
  verArchivos(item) {
    // Soporta múltiples archivos separados por coma o array
    let archivos = [];
    if (Array.isArray(item.ruta_img)) {
      archivos = item.ruta_img;
    } else if (typeof item.ruta_img === 'string' && item.ruta_img.includes(',')) {
      archivos = item.ruta_img.split(',').map(a => a.trim()).filter(Boolean);
    } else if (item.ruta_img) {
      archivos = [item.ruta_img];
    }
    this.archivosModal = archivos;
    this.dialogArchivos = true;
  },
  onTyping() {
  this.isTyping = true;
  clearTimeout(this.typingTimer);
  this.typingTimer = setTimeout(() => {
    this.isTyping = false; // después de 500ms sin escribir
  }, 500);
},
  // Método para permitir solo números (sin comas ni puntos) en presupuesto
  soloNumeros(event) {
    const char = String.fromCharCode(event.which);
    if (!/[0-9]/.test(char)) {
      event.preventDefault();
    }
  },
  // Método para permitir solo números enteros en el campo cantidad
  soloNumerosCantidad(event) {
    const char = String.fromCharCode(event.which);
    if (!/[0-9]/.test(char)) {
      event.preventDefault();
    }
  },
  // Método auxiliar para detectar teclas de control
  esTeclaControl(event) {
    const controlKeys = [8, 9, 13, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46];
    return controlKeys.includes(event.keyCode) || 
           (event.ctrlKey && [65, 67, 86, 88, 90].includes(event.keyCode));
  },
  // Método para permitir números con decimales (coma como separador decimal)
  soloNumerosConDecimales(event) {
    const char = String.fromCharCode(event.which);
    const currentValue = event.target.value;
    
    // Permitir números, comas (solo una) y teclas de control
    if (!/[0-9,]/.test(char) && !this.esTeclaControl(event)) {
      event.preventDefault();
      return;
    }
    
    // Si es coma, verificar que no haya ya una coma
    if (char === ',') {
      if (currentValue.includes(',')) {
        event.preventDefault();
      }
    }
  },
    // Formateo con separador de miles (punto) y decimales para presupuesto
    formatearNumero(campo, event) {
      let valor;
      if (typeof event === "string") {
        valor = event;
      } else if (event && event.target && event.target.value !== undefined) {
        valor = event.target.value;
      } else {
        valor = this.editedItem[campo] || "";
      }

      if (!valor || valor.trim() === "") {
        this.editedItem[campo] = "";
        return;
      }

      // ✅ NUEVO: Manejar decimales para el campo presupuesto
      if (campo === 'presupuesto') {
        // Separar parte entera y decimal
        let partes = valor.split(',');
        let parteEntera = partes[0] || '';
        let parteDecimal = partes[1] || '';

        // Limpiar parte entera (solo números)
        parteEntera = parteEntera.replace(/[^0-9]/g, '');
        
        // Limitar parte decimal a 2 dígitos
        if (parteDecimal.length > 2) {
          parteDecimal = parteDecimal.substring(0, 2);
        }

        // Formatear parte entera con separadores de miles (puntos)
        if (parteEntera.length > 3) {
          // Eliminar puntos existentes primero
          parteEntera = parteEntera.replace(/\./g, '');
          // Formatear cada 3 dígitos desde la derecha
          parteEntera = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        }

        // Construir valor final
        let valorFinal = parteEntera;
        if (parteDecimal) {
        }

        this.editedItem[campo] = valorFinal;
      } else {
        // ✅ Código original para otros campos (cantidad, etc.)
        const soloDigitos = valor.replace(/[^0-9]/g, "");
        const conMiles = soloDigitos.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        this.editedItem[campo] = conMiles;
      }
    },
    // Método auxiliar para parsear números formateados a valores numéricos
    parsearNumero(valorFormateado) {
      if (!valorFormateado || valorFormateado === '') return 0;
      // Remover puntos de miles y reemplazar coma decimal por punto
      const valorLimpio = valorFormateado.toString().replace(/\./g, '').replace(/,/g, '.');
      const numero = parseFloat(valorLimpio);
      return isNaN(numero) ? 0 : numero;
    },
    // Método para formatear números como moneda (con separadores de miles)
    formatearMoneda(valor) {
      if (valor === 0 || valor === null || valor === undefined) return '0';
      // Redondear a 2 decimales
      const valorRedondeado = Math.round(valor * 100) / 100;
      // Separar parte entera y decimal
      const partes = valorRedondeado.toFixed(2).split('.');
      let parteEntera = partes[0];
      const parteDecimal = partes[1];
      // Formatear parte entera con separadores de miles (puntos)
      parteEntera = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      // Retornar con coma como separador decimal si hay decimales distintos de 00
      if (parteDecimal && parteDecimal !== '00') {
        return parteEntera + ',' + parteDecimal;
      }
      return parteEntera;
    },
  },
};</script>

<style scoped>
/* ===== DISEÑO MODERNO Y ELEGANTE ===== */
.procesos-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  padding: 1.5rem;
  padding: 1.5rem;
}

.unified-container {
  width: 100%;
  max-width: 100%;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  background: white;
  border-radius: 0;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* ===== HEADER SECTION ===== */
.header-section {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%);
  padding: 2rem;
  padding: 2rem;
  color: white;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.header-section::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 50%,
    rgba(255, 255, 255, 0.05) 100%
  );
  pointer-events: none;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  position: relative;
  z-index: 2;
}

.title-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.title-text {
  flex: 1;
}

.main-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

.subtitle {
  font-size: 1rem;
  margin: 0;
  opacity: 0.9;
  font-weight: 400;
}

.header-actions {
  position: relative;
  z-index: 2;
}

.export-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
}

.export-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2) !important;
}

/* ===== SEARCH SECTION ===== */
.search-section {
  padding: 1.5rem 2rem;
  padding: 1.5rem 2rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.search-card {
  flex: 1;
  max-width: 500px;
}

.search-field {
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05) !important;
}

.create-btn-container {
  flex-shrink: 0;
}

.create-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.4) !important;
  transition: all 0.3s ease !important;
}

.create-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(59, 130, 246, 0.6) !important;
}

/* ===== TABLE SECTION ===== */
.table-section {
  padding: 0;
  background: white;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

.table-card {
  padding: 0;
  background: white;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

/* ===== DISEÑO MINIMALISTA ELEGANTE PARA TABLA ===== */
.modern-table {
  background: white !important;
  border-radius: 0 !important;
  overflow: visible !important;
  box-shadow: none !important;
  border: none !important;
  width: 100% !important;
  min-width: 800px; /* Ancho mínimo para forzar scroll si es necesario */
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
  overflow-x: scroll !important; /* Cambiar a scroll para que siempre aparezca */
  overflow-y: visible !important;
  background: white !important;
  width: 100% !important;
  max-width: 100%;
  scrollbar-width: thin; /* Para Firefox */
  scrollbar-color: #64748b #e5e7eb; /* Para Firefox */
}

/* Estilos para el scrollbar horizontal siempre visible */
.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  height: 12px !important; /* Más alto para mejor visibilidad */
  display: block !important;
  -webkit-appearance: none;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #e5e7eb !important; /* Más visible */
  border-radius: 6px !important;
  margin: 0 10px;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #64748b !important; /* Más oscuro para mejor visibilidad */
  border-radius: 6px !important;
  border: 2px solid #e5e7eb;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #475569 !important; /* Aún más oscuro al hover */
}

.modern-table >>> .v-data-table-header {
  background: #f9fafb !important;
  border-bottom: 2px solid #e5e7eb !important;
  position: relative !important;
}

.modern-table >>> .v-data-table-header tr {
  border-bottom: none !important;
}

.modern-table >>> .v-data-table-header th {
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.3px !important;
  padding: 0.65rem 0.5rem !important;
  background: transparent !important;
  border-bottom: 2px solid #e5e7eb !important;
  text-align: center !important;
  white-space: nowrap !important;
}

.modern-table >>> .v-data-table-header th.column[data-align="left"] {
  text-align: left !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr {
  transition: all 0.2s ease !important;
  border-bottom: 1px solid #f9fafb !important;
  height: auto !important;
  min-height: 35px !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:nth-child(even) {
  background: #fafbfc !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:hover {
  background: #f8fafc !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td {
  color: #1f2937 !important;
  font-weight: 400 !important;
  border-bottom: 1px solid #f3f4f6 !important;
  padding: 1rem 0.75rem !important;
  font-size: 0.875rem !important;
  line-height: 1.5 !important;
  padding: 1rem 0.75rem !important;
  font-size: 0.875rem !important;
  line-height: 1.5 !important;
  vertical-align: middle !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td:first-child {
  text-align: center !important;
  white-space: nowrap !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td:nth-child(2) {
  text-align: left !important;
  white-space: normal !important;
  word-wrap: break-word !important;
  min-width: 350px !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td:nth-child(n+3) {
  text-align: center !important;
  white-space: nowrap !important;
}

.modern-table >>> .v-data-table__wrapper table thead tr th {
  padding: 1rem 0.75rem !important;
  font-size: 0.85rem !important;
  white-space: nowrap !important;
}

.modern-table >>> .v-data-table__wrapper table thead tr th {
  padding: 1rem 0.75rem !important;
  font-size: 0.85rem !important;
}

/* ===== ICONOS DE ACCIONES MODERNOS ===== */
.action-icons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: center;
}

.action-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.action-icon {
  font-size: 18px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  padding: 3px !important;
  border-radius: 4px !important;
}

.view-icon {
  color: #3b82f6 !important;
}

.view-icon:hover {
  color: #1d4ed8 !important;
  transform: scale(1.1) !important;
}

.approve-icon {
  color: #059669 !important;
}

.approve-icon:hover {
  color: #047857 !important;
  transform: scale(1.1) !important;
}

.comment-icon {
  color: #3b82f6 !important;
}

.comment-icon:hover {
  color: #1d4ed8 !important;
  transform: scale(1.1) !important;
}

.edit-icon {
  color: #059669 !important;
}

.edit-icon:hover {
  color: #047857 !important;
  transform: scale(1.1) !important;
}

.delete-icon {
  color: #dc2626 !important;
}

.delete-icon:hover {
  color: #b91c1c !important;
  transform: scale(1.1) !important;
}

.pdf-icon {
  color: #dc2626 !important;
  font-size: 18px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  padding: 3px !important;
}

.pdf-icon:hover {
  color: #b91c1c !important;
  transform: scale(1.1) !important;
}

/* ===== FOOTER DE TABLA ===== */
.modern-table >>> .v-data-footer {
  background: white !important;
  border-top: 1px solid #e5e7eb !important;
  padding: 1.25rem !important;
  border-radius: 0 !important;
}

.modern-table >>> .v-data-footer__select {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
}

.modern-table >>> .v-data-footer__pagination {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 0.9rem !important;
}

.modern-table >>> .v-data-footer .v-btn {
  background: #f3f4f6 !important;
  color: #374151 !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
  transition: all 0.2s ease !important;
  font-size: 0.9rem !important;
  padding: 0.6rem 0.9rem !important;
  font-weight: 500 !important;
}

.modern-table >>> .v-data-footer .v-btn:hover {
  background: #e5e7eb !important;
  border-color: #d1d5db !important;
  transform: translateY(-1px) !important;
}

/* ===== SEND SECTION ===== */
.send-section {
  padding: 2rem;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: center;
}

.send-btn {
  background: linear-gradient(135deg, #059669 0%, #047857 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(5, 150, 105, 0.4) !important;
  transition: all 0.3s ease !important;
  min-width: 200px !important;
}

.send-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(5, 150, 105, 0.6) !important;
}

.send-btn:disabled {
  background: #9ca3af !important;
  color: #6b7280 !important;
  box-shadow: none !important;
  transform: none !important;
}

/* ===== SNACKBAR MODERNO ===== */
.modern-snackbar {
  border-radius: 8px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
}

/* ===== ESTILOS PARA MODAL ===== */
.archivo-preview-modal-director {
  cursor: pointer;
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.archivo-preview-modal-director:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.archivo-nombre-modal-director {
  font-size: 0.8rem;
  word-break: break-all;
  max-width: 160px;
  text-align: center;
  margin-bottom: 12px;
  color: #64748b;
  font-weight: 500;
}

/* ===== RESPONSIVE DESIGN ===== */

/* Laptops grandes (1920px y más) */
@media (min-width: 1920px) {
  .procesos-container {
    padding: 2rem;
  }
}

/* Laptops estándar (1366px - 1919px) */
@media (min-width: 1366px) and (max-width: 1919px) {
  .procesos-container {
    padding: 1.5rem;
  }

  .header-section {
    padding: 2rem;
  }

  .search-section {
    padding: 1.5rem 2rem;
  }

  .modern-table >>> .v-data-table__wrapper table tbody tr td {
    padding: 1rem 0.5rem !important;
    font-size: 0.85rem !important;
  }

  .modern-table >>> .v-data-table__wrapper table thead tr th {
    padding: 1rem 0.5rem !important;
    font-size: 0.8rem !important;
  }
}

/* Laptops grandes (1920px y más) */
@media (min-width: 1920px) {
  .procesos-container {
    padding: 2rem;
  }
}

/* Laptops estándar (1366px - 1919px) */
@media (min-width: 1366px) and (max-width: 1919px) {
  .procesos-container {
    padding: 1.5rem;
  }

  .header-section {
    padding: 2rem;
  }

  .search-section {
    padding: 1.5rem 2rem;
  }

  .modern-table >>> .v-data-table__wrapper table tbody tr td {
    padding: 1rem 0.5rem !important;
    font-size: 0.85rem !important;
  }

  .modern-table >>> .v-data-table__wrapper table thead tr th {
    padding: 1rem 0.5rem !important;
    font-size: 0.8rem !important;
  }
}

/* Laptops medianas (1024px - 1365px) */
@media (min-width: 1024px) and (max-width: 1365px) {
  .procesos-container {
    padding: 1rem;
  }

  .header-section {
    padding: 1.5rem;
  }

  .search-section {
    padding: 1.25rem 1.5rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .subtitle {
    font-size: 0.9rem;
  }

  .modern-table >>> .v-data-table__wrapper table tbody tr td {
    padding: 0.875rem 0.5rem !important;
    font-size: 0.8rem !important;
  }

  .modern-table >>> .v-data-table__wrapper table thead tr th {
    padding: 0.875rem 0.5rem !important;
    font-size: 0.75rem !important;
  }
}

/* Tablets (768px - 1023px) */
@media (max-width: 1023px) {
  .procesos-container {
    padding: 1rem;
  }

  .header-section {
    padding: 1.5rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .main-title {
    font-size: 1.4rem;
  }

  .search-section {
    padding: 1.25rem;
    flex-direction: column;
    gap: 1rem;
  }

  .search-card {
    max-width: 100%;
  }

  .table-card {
    overflow-x: auto; /* Mantener scroll horizontal */
  }

  .modern-table {
    min-width: 900px;
  }

  .modern-table >>> .v-data-table__wrapper {
    overflow-x: scroll !important; /* Mantener scroll horizontal */
  }
}

/* Móviles (menos de 768px) */
@media (max-width: 768px) {
  .procesos-container {
    padding: 0.75rem;
  }

  .unified-container {
    margin: 0;
    border-radius: 0;
    width: 100%;
  }

  .header-section {
    padding: 1.25rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 0.75rem;
  }

  .title-icon {
    width: 50px;
    height: 50px;
  }

  .main-title {
    font-size: 1.3rem;
  }

  .subtitle {
    font-size: 0.85rem;
  }

  .search-section {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
  }

  .search-card {
    max-width: 100%;
  }

  .create-btn {
    width: 100% !important;
  }

  .export-btn {
    width: 100% !important;
    margin-top: 0.5rem;
  }

  .table-card {
    overflow-x: auto; /* Mantener scroll horizontal */
  }

  .modern-table {
    min-width: 800px;
  }

  .modern-table >>> .v-data-table__wrapper {
    overflow-x: scroll !important; /* Mantener scroll horizontal */
  }

  .send-section {
    padding: 1.25rem;
  }
}
</style>